import { useCallback } from 'react';
import { VideoEvents, VideoStates } from '@msi-alta/opvideo-state-machine';

// Intercom button click handler
export const useIntercomCallButtonClick = ({
  currentVideoState,
  sendEvent,
  handleMicState,
}) => {
  return useCallback(() => {
    switch (currentVideoState) {
      case VideoStates.SURVEILLANCE:
        sendEvent({ type: VideoEvents.StartCall });
        break;
      case VideoStates.PREVIEW:
        handleMicState();
        sendEvent({ type: VideoEvents.JoinCall });
        break;
      case VideoStates.CALL:
        sendEvent({ type: VideoEvents.VideoDetails });
        break;
      default:
    }
  }, [currentVideoState, sendEvent, handleMicState]);
};
